import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@syneto/compass-react';

const PartnerPreviewEnrollmentNotice = ({ notifyCustomer, onNotifyCustomerChange, children }) => {
	return (
		<div>
			<p>This company will be enrolled in the Partner Preview Program. End users will be able to enable access to Preview updates for each registered machine from the Inventory side pane in Central Hub.</p>
			<Form.Check
				type="checkbox"
				id="partnerPreviewNotifyCustomer"
				label="Notify customer"
				checked={notifyCustomer}
				onChange={onNotifyCustomerChange}
			/>
			{notifyCustomer && children}
		</div>
	);
};

export default PartnerPreviewEnrollmentNotice;

PartnerPreviewEnrollmentNotice.propTypes = {
	notifyCustomer: PropTypes.bool.isRequired,
	onNotifyCustomerChange: PropTypes.func.isRequired,
	children: PropTypes.node
};
